export default __webpack_public_path__ + "static/media/abdyl.ab1615f8.png";